<template>
<section>
  <parallax-about ref="about-image"></parallax-about>
  <left-right-layout ref="left-right"></left-right-layout>
  </section>
</template>

<script>
import LeftRightLayout from "../components/LeftRightLayout.vue";
export default {
  components: {
    ParallaxAbout,
    LeftRightLayout
  }
};
import ParallaxAbout from "../components/ParallaxAbout";
</script>

<style>
</style>